import { ROUTES } from '@constants/routes.constants';
import { TabDefinition } from './creator-shell.types';

export const TABS: TabDefinition[] = [
  {
    id: 'Badges',
    type: 'component',
    icon: 'BadgeIcon',
    path: ROUTES.badges,
  },
  {
    id: 'Leaderboards',
    type: 'component',
    icon: 'RankingIcon',
    path: ROUTES.leaderboards,
  },
  {
    id: 'Community',
    type: 'route',
    path: ROUTES.community,
    icon: 'leaderboard',
    notificationGetter: (data) => data?.newPostNotifications?.unread_count || 0,
  },
  {
    id: 'Content',
    type: 'route',
    path: ROUTES.contents,
    icon: 'gem',
    notificationGetter: (data) => data?.newContentNotifications?.unread_count || 0,
  },
  {
    id: 'Challenges',
    type: 'route',
    path: ROUTES.challenges,
    icon: 'challenge',
    notificationGetter: (data) => data?.newNotificationsChallenge?.unread_count || 0,
  },
];
